import { insertIntoSupabase, selectFromSupabase, updateInSupabase, deleteFromSupabase } from "../helpers/supabase-api";

/**
 * Create a new note
 * @param {object} noteData - object containing the note data
 */
export function createNote(noteData) {
  // Map frontend structure to database structure
  const dbData = {
    content: noteData.content,
    ts: noteData.ts,
    block_ref: noteData.blockRef || null,
    project_ref: noteData.projectRef || null,
    data: noteData
  };
  
  return insertIntoSupabase("notes", dbData).then(result => {
    // Return in FaunaDB-compatible format for frontend compatibility
    return {
      ref: {
        value: {
          id: result.id
        }
      },
      data: {
        ...noteData,
        id: result.id
      }
    };
  });
}

export function getNotes() {
  return selectFromSupabase("notes", "*").then(notes => {
    // Transform to FaunaDB-compatible format
    const transformedData = notes.map(note => ({
      ref: {
        value: {
          id: note.id
        }
      },
      data: {
        id: note.id,
        content: note.content,
        ts: note.ts,
        blockRef: note.block_ref,
        projectRef: note.project_ref,
        created_at: new Date(note.created_at).getTime(),
        ...note.data
      }
    }));
    
    return { data: transformedData };
  });
}

/**
 * Delete a note
 * @param {string} id - note ID to delete
 */
export function deleteNote(id) {
  return deleteFromSupabase("notes", { id });
}

/**
 * Update a note
 * @param {string} id - note ID to update
 * @param {object} noteData - object of data to update
 */
export function updateNote(id, noteData) {
  // Map frontend data to database structure
  const dbData = {};
  if (noteData.content) dbData.content = noteData.content;
  if (noteData.ts) dbData.ts = noteData.ts;
  if (noteData.blockRef) dbData.block_ref = noteData.blockRef;
  if (noteData.projectRef) dbData.project_ref = noteData.projectRef;
  
  // Store full note data in data field as well
  dbData.data = noteData;
  
  return updateInSupabase("notes", dbData, { id });
}
